export const ensureApiSuccess = (response) => {
  const status = response?.response?.status ?? response?.status
  const data = response?.response?.data ?? response?.data

  if (status >= 200 && status < 300 && data?.status !== 'error') return response
  if (response instanceof Error) throw response

  const error = new Error(data?.error || 'Ошибка запроса')
  error.response = response?.response ?? response
  throw error
}
